RhUtils.DeselecionadorSimpleGridComModalEBtl = (function(){
    var disposeModalBase;
    var attachedGrid;
    var disposeModalNew = function(){
        //Já esconde o modal pra não ficar na tela de "carregando"
        Benner.ModalPage.hide();

        //Faz um request pra saber se rodou ou não o BTL
        var request = $.get(Benner.Page.getApplicationPath() + "api/AsyncProcesses");
        request.done(function (result) {
            var detail = null;
            for (var i = result.length - 1; i >= 0; i--) {
                detail = result[i];
                if(!detail.ToastrDisplayed) {
                    var parentId = $(`#${Benner.Grid[attachedGrid].id}`).parent().attr("id");
                    //se ainda tem algum toastr que ainda não mostrou
                    //deseleciona tudo pq o BTL foi disparado com sucesso
                    deSelectAllRows(Benner.Grid[attachedGrid].id, parentId)
                    break;
                }
            }
        });

        
        request.always(function() {
            //se deu boas ou se deu ruim, chama o dispose base da tec 
            // (deve chamar só depois que o request terminou)
            disposeModalBase();
        });
    }
    var deSelectAllRows = function(widgetId, gridClientId){
        var checkboxlist = $(`#${gridClientId} td.multi-select-column label > input:enabled`);
        
        $(checkboxlist).prop("checked", false);
        $(checkboxlist).parents("tr").removeClass("active");
        $(`#SelectHandlesInput_${widgetId}`).val('');
        
        if (Benner.Grid[widgetId] && Benner.Grid[widgetId].refreshOnSelectRows)
            Benner.Grid[widgetId].refresh();
    }
    return {
        init: function(grid){
            attachedGrid = grid;
            
            //Faz o override da função da tec para a nossa
            disposeModalBase = Benner.Widget.disposeModal;
            Benner.Widget.disposeModal = disposeModalNew;
            
        }
    }
})()